
import { makeStyles } from "@material-ui/core/styles";
import {logoMAS,microfoftLogo,bgImage} from '../../asset'

const loginStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
      },
      margin: {
        margin: theme.spacing(1),
      },
    logInPage:{
        display: 'flex',
       height: '100vh',
       },
       signInWrapper: {
           width: '100%',
           display: '-ms-flexbox',
           backgroundImage: `url("${bgImage}")`,
           backgroundRepeat: 'repeat-x',
           backgroundPosition: '50% 92%',
           position: 'relative',
           backgroundSize: 'cover',
           [theme.breakpoints.down('sm')]:{
            backgroundPosition: '62% 92%',
           },
       },  
    
          loginContentWrapper:{
            margin:'100px 0 0 70px',
            [theme.breakpoints.down('sm')]:{
              margin:'100px 0 0 40px',
             },
          },
          loginBtn:{
            "& .MuiButton-root":{
            border:'2px solid #c2c2c2 !important',
            padding:'12px 2px 12px 65px',
            backgroundImage: `url("${microfoftLogo}")`,
            backgroundRepeat:'no-repeat',
            width:'450px',
            borderRadius:'5px 5px 5px 5px',
            backgroundColor:'#fff',
            borderColor:'#a2a2a2',
            textAlign:'left',
            backgroundPosition: 'center left',
            fontSize:'16px',
            float:'left',
            [theme.breakpoints.down('sm')]:{
              width:'300px',
             },
          },
          },

          logoWrapper:{
             float:'left',
             width:'100%', 
          },
          loginPageLogo:{
           backgroundImage: `url("${logoMAS}")`,
            float:'left',
            width:'200px',
            height:'88px',
    
          },
          microfoftLogo:{
           // backgroundImage: `url("${microfoftLogo}")`,
            float:'left',
            width:'465px',
            height:'107px',
    
          },
          loginDataRowOne:{
            margin:'90px 0 50px 0',
            float:'left',
            textAlign:'left',
          },
          loginDataRowTwo:{
            margin:'5px 0 5px 0',
          },
          loginDataRowThree:{
            margin:'5px 0 50px 0',
          },
          TxtOne:{
            fontSize:'36px',
            fontWeight:'bold',
            color:'#535353',
            textTransform:'uppercase',
            width:'100%',
            float:'left',
          },
          TxtTwo:{
            fontSize:'26px',
            color:'#535353',
            width:'100%',
            float:'left',
            textTransform:'uppercase',
            [theme.breakpoints.down('sm')]:{
              fontSize:'24px',
             },
          },
          TxtTree:{
            fontSize:'20px',
            fontWeight:'bold',
            color:'#535353',
            textTransform:'uppercase',
          },
}));

export default loginStyles;